export const SignupTokenErrors = {
  IncorrectToken: 'incorrect_token',
  ContactDeleted: 'contact_deleted',
  CreationCompleted: 'creation_completed',
  ExpiredToken: 'expired_token'
};
